import { Timezone } from "@m7-health/shared-utils";

import { QueryBuilder } from "@mui/icons-material";
import { Chip, Tooltip, Typography } from "@mui/material";

import { white } from "@/common/theming";
import { Timezone as LegacyTimezone } from "@/common/types";
import { timezoneLabel } from "@/common/utils/dates";

// eslint-disable-next-line @typescript-eslint/no-duplicate-type-constituents
export const TimezoneTag = ({ timezone }: { timezone?: LegacyTimezone | Timezone }) =>
  timezone ? (
    <Tooltip
      title={
        <Typography
          children={`${timezone}  (${timezoneLabel(timezone, { format: "long" })})`}
          sx={{ color: white, fontSize: "13px" }}
        />
      }
    >
      <Chip
        className="timezone-chip"
        size="small"
        icon={<QueryBuilder />}
        label={timezoneLabel(timezone)}
      />
    </Tooltip>
  ) : null;
